import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SortState {
  order: string;
  direction: boolean;
  pageNumber: number;
  totalPages: number;
}

const initialState: SortState = {
  order: "Name",
  direction: true,
  pageNumber: 1,
  totalPages: 1,
};

const sort = createSlice({
  name: "sort",
  initialState,
  reducers: {
    sortOrder(state, { payload }: PayloadAction<string>) {
      if (payload) {
        state.order = payload;
      }
    },
    sortDirection(state) {
      state.direction = !state.direction;
    },
    setSortDirection(state, { payload }: PayloadAction<boolean>) {
      state.direction = payload;
    },
    setPageNumber(state, { payload }: PayloadAction<number>) {
      state.pageNumber = payload;
    },
    setTotalPages(state, { payload }: PayloadAction<number>) {
      state.totalPages = payload;
    },
  },
});

export const {
  sortOrder,
  sortDirection,
  setSortDirection,
  setPageNumber,
  setTotalPages,
} = sort.actions;

export default sort.reducer;
